import React from "react"
import App from "./App"
import { BrowserRouter } from "react-router-dom"
import { createRoot } from "react-dom/client"
import { initializeGTM } from "./utils/gtm"

// Initialize Google Tag Manager
initializeGTM()

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root")!)

root.render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.VITE_URL_PREFIX}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
